import { ComponentType, FC, ReactNode } from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

type Props = {
  icon?: ComponentType<any>;
  loading?: boolean;
  label?: ReactNode;
};

const SidebarBox: FC<Props> = props => {
  const { icon: Icon, children, label, loading = false } = props;

  return (
    <Box
      sx={[
        {
          pt: 2,
          pr: 1,
          pb: 2,
          pl: 1,
        },
        () =>
          Icon
            ? {
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
              }
            : {},
      ]}>
      {Icon &&
        (loading ? (
          <CircularProgress size={20} sx={{ mr: 1 }} />
        ) : (
          <Icon fontSize="small" sx={{ mr: 1 }} />
        ))}

      {label && (
        <Typography variant="caption" component="div">
          {label}
        </Typography>
      )}

      <Typography component="div" variant="body2">
        {children}
      </Typography>
    </Box>
  );
};

export default SidebarBox;
